import React, {Component} from "react"
import {translate} from "react-i18next"
import PropTypes from "prop-types"

import {Col} from "../../components/Grid"

import styles from "./styles.css"

import badge from "../../assets/icons/badge_blank.png"
import logo from "../../assets/icons/logo.png"

class ModuleCertificate extends Component {
  constructor() {
    super()

    this.state = {}

    this.renderArticles = this.renderArticles.bind(this)
  }

  static propTypes = {
    moduleName: PropTypes.string,
    articleTitles: PropTypes.arrayOf(PropTypes.string),
    username: PropTypes.string,
    date: PropTypes.string,
    isPrinting: PropTypes.bool,
    closePrintDialog: PropTypes.func
  }

  static defaultProps = {
    moduleId: 0,
    moduleName: "",
    articleTitles: [],
    username: "",
    date: "",
    isPrinting: false,
    closePrintDialog: () => {}
  }

  renderArticles(divider, col = false, item, index) {
    if (divider) {
      if (col === "is_left" && index >= divider) {
        return null
      }
      if (col === "is_right" && index < divider) {
        return null
      }
    }
    return <li key={index}>{item}</li>
  }

  render() {
    const {
      moduleId,
      moduleName,
      articleTitles,
      isPrinting,
      closePrintDialog,
      username,
      date,
      t
    } = this.props
    let splitBy = false
    let isTwoCols = articleTitles.length > 6
    if (articleTitles !== "undefined" && isTwoCols) {
      splitBy = Math.ceil(articleTitles.length / 2)
    }

    return (
      <Col
        className={`${styles.CrtPrint} crt-print ${
          isPrinting ? "is-active" : ""
        }`}
      >
        <button onClick={closePrintDialog}>
          <i className="icon icon-close" />
        </button>
        <section id={`crt-print-module-${moduleId}`} className="page">
          <div className="inner">
            <div className="logo">
              <img src={logo} alt="abat+ Lernplattform" width="75" height="75" />
            </div>
            <div className="intro">
              <h1>{t("Teilnahmebestätigung")}</h1>
            </div>
            <div className="participant">{username}</div>
            <div className={`courses ${isTwoCols ? "columns" : ""}`}>
              <p
                dangerouslySetInnerHTML={{
                  __html: t(
                    'hat das Modul "{{module}}" erfolgreich durchgeführt.',
                    {
                      module: moduleName,
                      interpolation: {escapeValue: false}
                    }
                  )
                }}
              />
              <p>{t("Inhalte des Moduls:")}</p>
              {articleTitles.length > 0 ? (
                isTwoCols ? (
                  <div className="flexbox">
                    <ol className="col-left">
                      {articleTitles.map(
                        this.renderArticles.bind(this, splitBy, "is_left")
                      )}
                    </ol>
                    <ol
                      className="col-right"
                      start={`${splitBy}`}
                      style={{"--s": splitBy}}
                    >
                      {articleTitles.map(
                        this.renderArticles.bind(this, splitBy, "is_right")
                      )}
                    </ol>
                  </div>
                ) : (
                  <ol>
                    {articleTitles.map(
                      this.renderArticles.bind(this, false, false)
                    )}
                  </ol>
                )
              ) : (
                <ol>
                  <li>Zertifikat bestätigt den Abschluss</li>
                  <li>Zertifikat bestätigt den Abschluss</li>
                  <li>Zertifikat bestätigt den Abschluss</li>
                  <li>Zertifikat bestätigt den Abschluss</li>
                </ol>
              )}
            </div>
            <div className="outro">
              <h3>{t("Herzlichen Glückwunsch!")}</h3>
            </div>
            <div className="badge">
              <img src={badge} alt="abat+ Lernplattform" />
              <span className="date">{date}</span>
            </div>
            <div className="footer">
              <div className="col-left">
                <img src={logo} alt="abat+ Lernplattform" />
                <p>
                  {t("Einfach")} <strong>{t("LERNEN")}</strong> –<br />
                  {t("Einfach")} <strong>{t("FINDEN")}</strong>
                </p>
              </div>
            </div>
          </div>
        </section>
      </Col>
    )
  }
}

export default translate()(ModuleCertificate)



// WEBPACK FOOTER //
// ./src/components/ModuleCertificate/index.js